module.exports = __webpack_public_path__ + "img/64.dcaa2c12.jpg";